import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as Rx from 'rxjs';
import { AppSettingService } from '../app.service';
import { UserInfoService } from '../user/user-info.service';

export interface INotification {
	NotificationPersonId: string,
	NotificationId: string,
	Notification: string,
	TypeId: string,
	Type: string,
	NotificationTime: string,
	ActionUrl: string,
	CommentPostId: string,
	JobPostId: string,
	CareerId: string,
	ImageIcon: string,
	Username: string,
	MinutesAgo: number,
	Age: string
}

@Injectable({
	providedIn: 'root'
})
export class NotificationAPIService {
	constructor(
		private userInfo: UserInfoService,
		private http: HttpClient
	) { }

	private url = AppSettingService.appConfig.JourneyAPIUrl + "Notification";

	getNotifications(limit: number, offset: number): Rx.Observable<INotification[]> {
		return this.http.get<any>(
			this.url + "?limit=" + limit.toString() + "&offset=" + offset.toString(),
			{
				withCredentials: true,
				headers: { 'Authorization': this.userInfo.authHeader(false) }
			}
		);
	}

	deleteNotification(notificationPersonId: string): Rx.Observable<any> {
		return this.http.delete<any>(
			this.url + "/" + encodeURIComponent(notificationPersonId),
			{
				withCredentials: true,
				headers: { 'Authorization': this.userInfo.authHeader(false) }
			}
		);
	}

	deleteMultipleNotifications(notificationPersonIDs: any): Rx.Observable<any> {
		return this.http.post<any>(
			this.url ,
			notificationPersonIDs,
			{
				withCredentials: true,
				headers: { 'Authorization': this.userInfo.authHeader(false) }
			}
		);
	}  
}

